import i18n from 'services/base/i18n';

export default {
  apply:                 () => i18n.pgettext('Pages|List History|Filter History', 'APPLY'),
  startDateLabel:        () => i18n.pgettext('Pages|List History|Filter History', 'START DATE'),
  endDateLabel:          () => i18n.pgettext('Pages|List History|Filter History', 'END DATE'),
  directionsLabel:       () => i18n.pgettext('Pages|List History|Filter History', 'DIRECTIONS'),
  directionsPlaceholder: () => i18n.pgettext('Pages|List History|Filter History', 'Outbound, Inbound, Local'),
  actionsLabel:          () => i18n.pgettext('Pages|List History|Filter History', 'ACTIONS'),
  actionsPlaceholder:    () => i18n.pgettext('Pages|List History|Filter History', 'Allowed, Blocked'),
  protocolsLabel:        () => i18n.pgettext('Pages|List History|Filter History', 'PROTOCOLS'),
  protocolsPlaceholder:  () => i18n.pgettext('Pages|List History|Filter History', 'Add Protocol'),
  sitesLabel:            () => i18n.pgettext('Pages|List History|Filter History', 'SITES'),
  sitesPlaceholder:      () => i18n.pgettext('Pages|List History|Filter History', 'Add Site'),
  devicesLabel:          () => i18n.pgettext('Pages|List History|Filter History', 'DEVICES'),
  devicesPlaceholder:    () => i18n.pgettext('Pages|List History|Filter History', 'Add Device'),
  locationsLabel:        () => i18n.pgettext('Pages|List History|Filter History', 'LOCATIONS'),
  locationsPlaceholder:  () => i18n.pgettext('Pages|List History|Filter History', 'Add Location'),
  invalidDirections:     () => i18n.pgettext('Pages|List History|Filter History', 'At least one item is required'),
  invalidActions:        () => i18n.pgettext('Pages|List History|Filter History', 'At least one item is required'),
};
